import {ObjectUtil} from '../../util/object-util';
import {ProposalStatus} from '../../enum/proposal-status';
import {BinaryData} from './binary-data';

export class ProposalInformation {
  id: string = null;
  creationDate: Date = null;
  riskDateBegin: Date = null;
  riskDateEnd: Date = null;
  leadInsurerNeeded: boolean = false;
  followingInsurerNeeded: boolean = false;
  coveragePercentageRequested: number = null;
  mainDueDate: string = null;
  deadline: Date = null;
  paymentMethod: string = null;
  lineOfBusiness: string = null;
  lineOfBusinessSubcategory: string = null;
  currency: string = 'EUR';
  riskDescriptionFreeText: string = null;
  individualClausesFreeText: string = null;
  individualConditionsFreeText: string = null;
  seatNumber: string;
  proposalName: string = null;
  classificationTerm: string = null;

  insuredAmount: number = null;
  insuredAmountCurrency: string = null;
  amountDescription: string = null;
  annualSalesAmount: number = null;
  annualSalesDescription: string = null;
  status: ProposalStatus = null;
  countriesWithLocalPolicies: string[] = null;
  emailsReceivedPDFWithDate: string[] = null;
  hasLeading: boolean = null;
  attachedFiles: BinaryData[] = [];
  otherInformation: string = null;
  usersAllowedToView: string[] = [];
  privateProposal: boolean = false;
  coverage: number = null;
  insuredSumType: string = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object, ['creationDate', 'riskDateBegin', 'riskDateEnd', 'deadline']);
  }

  update(object: any) {
    ObjectUtil.assign(this, object, ['deadline', 'riskDateEnd', 'riskDateBegin', 'creationDate']);
  }
}
